export default function Logo({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path
        d="M24 4C13 4 4 12 4 23q5-5 10 0 5-5 10 0 5-5 10 0 5-5 10 0C44 12 35 4 24 4Z"
        fill="#E85D04"
      />
      <circle cx="24" cy="15" r="2.6" fill="#FFD166" />
      <circle cx="15" cy="18" r="2.1" fill="#F472B6" />
      <circle cx="33" cy="18" r="2.1" fill="#F472B6" />
      <path
        d="M24 23v14a4.5 4.5 0 0 1-9 0"
        stroke="#3A5A40"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
